import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-storytelling',
  templateUrl: './digital-storytelling.component.html',
  styleUrls: ['./digital-storytelling.component.scss'],
})
export class DigitalStorytellingComponent implements OnInit {
  modulesText = {
    text: 'Nell’ambito del corso gli alunni apprenderanno i concetti base dello storytelling che peermetteranno loro di costruire una storia e successivamente di calarla in una forma e in un contesto digitali.',
  };

  constructor() {}

  ngOnInit(): void {}
}
